module.exports = __webpack_public_path__ + "static/media/logo_front.e0d84acf.svg";